import { Base } from '@studiometa/js-toolkit';
import withMapbox from './withMapbox.js';
// F3 (revue finale du 2026-09-24) : le titre/l'adresse lus depuis
// `data-option-*` (single-stores.php) étaient injectés bruts dans
// `Popup.setHTML()`, contenu ET attribut `alt`.
import escapeHtml from './escapeHtml.js';

/**
 * MapboxMarker
 */
export default class MapboxMarker extends withMapbox(Base) {
  static config = {
    name: 'MapboxMarker',
    options: {
      lng: Number,
      lat: Number,
      title: String,
      address: String,
      img: String,
      icon: String,
      type: String,
    },
  };

  marker;

  /**
   * markerOptions
   * @returns {object}
   */
  get markerOptions() {
    return {
      draggable: this.$options.draggable,
    };
  }

  /**
   * LngLat
   * @returns {Array}
   */
  get lngLat() {
    return [this.$options.lng, this.$options.lat];
  }

  /**
   * @returns {string}
   */
  get icon() {
    return this.$options.type === 'concept-store'
      ? `${window.location.origin}/wp-content/themes/Divi-child/assets/pin-reseller.png`
      : `${window.location.origin}/wp-content/themes/Divi-child/assets/pin.png`;
  }

  /**
   * mounted
   */
  mounted() {
    const el = document.createElement('div');
    el.className = 'marker';
    el.style.backgroundImage = `url(${this.icon})`;
    el.style.backgroundSize = 'contain';
    el.style.width = '48px';
    el.style.height = '48px';
    this.marker = new this.mapbox.Marker(el).setLngLat(this.lngLat).addTo(this.map);

    const { title, img, address } = this.$options;
    // Échappement (F3) : title/address/img viennent de data-option-* sur
    // single-stores.php (déjà protégés en esc_attr() côté PHP), mais restent
    // du texte non fiable une fois relus ici — échappés avant insertion en
    // contenu/attribut HTML, jamais injectés bruts.
    const safeTitle = escapeHtml(title);
    const safeImg = escapeHtml(img);
    const safeAddress = escapeHtml(address);

    this.map.flyTo({
      center: this.lngLat,
      offset: [0, -100],
    });

    new this.mapbox.Popup({ offset: [0, 50] })
      .setLngLat(this.lngLat)
      .setHTML(
        `
          <div class="map-popup">
            ${img ? `<img src="${safeImg}" alt="${safeTitle}" width="282" height="158" />` : ``}
            <p class="map-popup__title">
              ${
                this.$options.type === 'concept-store'
                  ? `<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect y="0.567871" width="24" height="24" rx="12" fill="#F6BB41"/>
                      <path d="M7.63574 6.95241H8.66728V8.05109C9.46687 7.14162 10.6632 6.56787 11.9999 6.56787C14.3743 6.56787 16.3092 8.38679 16.3641 10.6574V18.5679H15.3326V10.6574C15.2777 8.93613 13.8066 7.55668 11.9999 7.55668C10.1932 7.55668 8.72221 8.93613 8.66728 10.6574V18.5679H7.63574V6.95241Z" fill="#000"/>
                     </svg>`
                  : ``
              }
              ${safeTitle}
            </p>
            <p class="map-popup__address">${safeAddress}</p>
          </div>
        `,
      )
      .addTo(this.map);
  }

  /**
   * destroyed
   */
  destroyed() {
    this.marker?.remove();
  }
}
